import { ViewStream } from "spyne";
import CreateBtnTmpl from './templates/ui-create-app-btn.tmpl.html';
export class UICreateAppBtn extends ViewStream {
  constructor(props = {}) {
    props.id = "create-app-btn-holder";
    //props.class = "btn btn-create";
    props.dataset = {};
    props.dataset["eventType"] = "authEvent";
    props.dataset["type"] = "createApp";
    props.channels = ["CHANNEL_AUTH"];
    const lsHideLoginVal = localStorage.getItem('showTheLogin');
    const hideLoginBool = String(lsHideLoginVal) !== 'true';
    const hideLoginClass = hideLoginBool ? 'hide-login' : '';
    const disableClass =   hideLoginBool ? 'btn btn-create disabled' : 'btn btn-create';
    props.data = {hideLoginClass, disableClass}
    props.class = hideLoginClass;

    props.template = CreateBtnTmpl;
    props.templateOld = `<button id="create-app-btn" class="btn btn-create"><i class="icon"></i><span>CREATE APP</span></button>`;

    super(props);
  }

  addActionListeners() {
    return [
      ["CHANNEL_AUTH_APP_CREATE_GENERATING_EVENT", "onAppGeneratingEvent"],
      ["CHANNEL_AUTH_APP_CREATE_COMPLETED_EVENT", "onAppCompletedEvent"]
    ];
  }

  onAppGeneratingEvent(e) {
    this.props.button$.setClass("btn btn-generating");
    this.props.button$(".btn-text").el.innerText = "GENERATING APP";

    //console.log("BUTTON ", this.props.button$, this.props.button$('span').el);
    //console.log("BTN SET GENERATING CLASS ", this.props.el$, this.props.el, { e });
  }
  onAppCompletedEvent(e) {
    this.props.button$.setClass("btn btn-complete");
    this.props.button$(".btn-text").el.innerText = "PREVIEW APP";
  //console.log"BTN SET SUCCESS CLASS ", this.props.el$, this.props.el, { e });
  }
  broadcastEvents() {
    return [["#create-app-btn", "click"]];
  }

  onRendered() {
    this.props.button$ = this.props.el$("button#create-app-btn");

   // window.setTimeout(this.onAppCompletedEvent.bind(this), 4000);

  }
}
